import { Stack } from '@moda/om';
import React, { useCallback, useEffect } from 'react';
import { useFeatureFlag } from '@moda/portal-stanchions';
import { RefreshedMobileSiteNavMenuVerticalCategory } from '../RefreshedMobileSiteNavMenuVerticalCategory';
import { useRefreshedMobileSiteNavMenuQuery } from '../useRefreshedMobileSiteNavMenuQuery.';
import { RefreshedMobileSiteNavMenuQuery_displayPage_data_tabs_imageCategories as ImageCategories } from '../../../../generated/types/RefreshedMobileSiteNavMenuQuery';
import { RefreshedMobileSiteNavMenuVerticalImages } from './RefreshedMobileSiteNavMenuVerticalImages';

import './RefreshedMobileSiteNavMenuVertical.scss';

const DEFAULT_IMAGE_CATEOGRY_NAME = 'clothing';
const FASHION_TAB_NAME = 'fashion';

interface Props {
  selectedTab?: string;
  onResetScroll: () => void;
  onClose: () => void;
}

export const RefreshedMobileSiteNavMenuVertical: React.FC<Props> = ({
  selectedTab,
  onResetScroll,
  onClose
}) => {
  const { tabs } = useRefreshedMobileSiteNavMenuQuery();

  const categoryFromFeatureFlag = useFeatureFlag<undefined | string>(
    'refreshed-mobile-nav-fashion-tab-image-category-name',
    [
      {
        default: undefined
      },
      {
        getFromTreatment: treatment => treatment.toString()
      }
    ]
  );

  const getCurrentCategory = useCallback(
    (imageCategories: ImageCategories[]) => {
      if (!selectedTab) return;

      if (imageCategories.length === 0) return;

      if (selectedTab === FASHION_TAB_NAME) {
        const imagesFromFeatureFlag = imageCategories.find(
          category => category.name === categoryFromFeatureFlag
        )?.images;

        if (imagesFromFeatureFlag && imagesFromFeatureFlag.length) {
          return imagesFromFeatureFlag;
        }

        const imagesFromDefaultCategory = imageCategories.find(
          category => category.name === DEFAULT_IMAGE_CATEOGRY_NAME
        )?.images;

        return imagesFromDefaultCategory;
      }

      return imageCategories[0].images;
    },
    [categoryFromFeatureFlag, selectedTab]
  );

  useEffect(() => onResetScroll(), [onResetScroll, selectedTab]);

  const tabData = tabs?.find(tab => tab.label.toLowerCase() === selectedTab?.toLowerCase());

  if (!tabData) return null;

  const { mainCategories, imageCategories } = tabData;

  const currentyCategoryImages = getCurrentCategory(imageCategories);

  if (!mainCategories) return null;

  const options =
    mainCategories.length === 1 ? mainCategories[0].mainCategoryItems : mainCategories;

  if (!options) return null;

  return (
    <Stack className="RefreshedMobileSiteNavMenuVertical" space={4}>
      {options.map((option, index) => (
        <RefreshedMobileSiteNavMenuVerticalCategory key={index} data={option} onClose={onClose} />
      ))}

      <RefreshedMobileSiteNavMenuVerticalImages images={currentyCategoryImages} />
    </Stack>
  );
};
